module.exports = __webpack_public_path__ + "img/logo-ALERCE.827ab815.svg";